import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import {
    AppointmentWizardDateStore,
    AppointmentWizardDateState,
} from './appointment-wizard-date.store';
import { AppointmentWizardDate } from './appointment-wizard-date.model';

@Injectable({
    providedIn: 'root',
})
export class AppointmentWizardDateQuery extends QueryEntity<
    AppointmentWizardDateState,
    AppointmentWizardDate
> {
    constructor(protected store: AppointmentWizardDateStore) {
        super(store);
    }
}
